import { render } from "./SettingsTab.vue?vue&type=template&id=0c847e80&scoped=true"
import script from "./SettingsTab.vue?vue&type=script&lang=js"
export * from "./SettingsTab.vue?vue&type=script&lang=js"

import "./SettingsTab.vue?vue&type=style&index=0&id=0c847e80&scoped=true&lang=scss"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c847e80"]])

export default __exports__